module.exports = __webpack_public_path__ + "static/img/i117.02de81d5.png";